import { useState } from "react";
import { InvarDataAccess } from "../../../data/InvarDataAccess";
import { ConveyanceResponse } from "../../../data/InvarDataModels/ConveyanceResponse";
import { ConveyanceConfigResponse } from "../../../data/InvarDataModels/ConveyanceConfigResponse";
import { ActionIntakeResponse } from "../../../data/InvarDataModels/ActionIntakeResponse";

interface IProps {
  IDA: InvarDataAccess;
  Conveyance: ConveyanceResponse;
  theseConveyanceConfigs: Array<ConveyanceConfigResponse>;
  setTheseConveyanceConfigs: (inbound: Array<ConveyanceConfigResponse>) => void;
}

export const InvarAdminConveyanceConfigs = (props: IProps) => {
  const [showAddConfig, setShowAddConfig] = useState(false);
  const [_nbConfigName, setConfigName] = useState("");
  const [_nbConfigValue, setConfigValue] = useState("");

  return (
    <div className="ConvConfig">
      <div className="ConvConfigTitleRow">
        <div className="ConvConfigTitle">Conveyance Configuration:</div>
        <div
          className="ConvConfigAddButton"
          onClick={() => {
            setShowAddConfig(!showAddConfig);
          }}
        >
          {!showAddConfig ? "[+]" : "[>]"}
        </div>
      </div>
      {showAddConfig ? (
        <div className="ConvConfAddRack">
          <label htmlFor="ConvConfNewName">Name:</label>
          <input
            id="ConvConfNewName"
            required={true}
            type="text"
            value={_nbConfigName}
            onChange={(ev) => {
              setConfigName(ev.target.value);
            }}
            className="ConvConfigAddName"
          ></input>
          <label htmlFor="ConvConfNewValue">Value:</label>
          <input
            id="ConvConfNewValue"
            onChange={(ev) => {
              setConfigValue(ev.target.value);
            }}
            value={_nbConfigValue}
            className="ConvConfigAddValue"
            type="text"
          ></input>
          <button
            disabled={_nbConfigName === "" || _nbConfigValue === ""}
            className="ConvConfigAdd"
            onClick={async () => {
              if (_nbConfigName !== "" && _nbConfigValue !== "") {
                props.setTheseConveyanceConfigs(
                  [...props.theseConveyanceConfigs]
                    .concat(
                      await props.IDA.CreateConveyanceConfig(
                        _nbConfigName,
                        _nbConfigValue,
                        props.Conveyance.ConveyanceID,
                      ),
                    )
                    .sort((l, r) => {
                      if (
                        l.ConfigName.toLowerCase() < r.ConfigName.toLowerCase()
                      )
                        return -1;
                      if (
                        l.ConfigName.toLowerCase() > r.ConfigName.toLowerCase()
                      )
                        return 1;
                      return 0;
                    }),
                );
                setConfigName("");
                setConfigValue("");
              }
            }}
          >
            Add
          </button>
        </div>
      ) : (
        ""
      )}
      <div className="ConvConfigBody">
        {props.theseConveyanceConfigs.map((th, i) => {
          return (
            <div className="ConvConfig" key={"brokerage_" + i.toString()}>
              <div className="ConvConfName">{th.ConfigName}</div>
              <div className="ConvConfValue">{th.ConfigValue}</div>
              <div
                className="InvarButton ConvConfigDelete"
                onClick={async () => {
                  if (
                    await props.IDA.DeleteConveyanceConfig(
                      th.ConveyanceConfigID,
                    )
                  ) {
                    props.setTheseConveyanceConfigs(
                      [...props.theseConveyanceConfigs]
                        ?.filter(
                          (ith) =>
                            ith.ConveyanceConfigID !== th.ConveyanceConfigID,
                        )
                        .sort((l, r) => {
                          if (
                            l.ConfigName.toLowerCase() <
                            r.ConfigName.toLowerCase()
                          )
                            return -1;
                          if (
                            l.ConfigName.toLowerCase() >
                            r.ConfigName.toLowerCase()
                          )
                            return 1;
                          return 0;
                        }),
                    );
                  }
                }}
              >
                Delete
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
